import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/providers.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/admin/AdminLayout.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/footer/ZaloButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/footer/ZaloButton2.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/header/MainHeader.js");
